import { P4SVGIcon } from '../components/SVGIcons/SVGIcons';
import { JSXElementConstructor } from 'react';
import { RouteComponentProps } from 'react-router';
import { IFolder, IFullUserDetails, IScreen } from '../graphql/schema/p4types';

export type IMenuEntry = {
  url?: string;
  title?: string;
  shortTitle?: string;
  icon?: string | P4SVGIcon;
  component?: JSXElementConstructor<any>;

  /**
   * @deprecated - Prefer using 'component' with hooks to access route params/etc - Will be easier to migrate to react-router 6+
   */
  render?: (props: RouteComponentProps<any>) => JSX.Element;
  exact?: boolean;
  screenReference?: string;
  parent?: string;
  operations?: number;
  actions?: any;
  permissionLabel?: string;
  excludeSearch?: boolean;
  beta?: boolean;
  ignoreInSearch?: boolean;
  report?: boolean;
  section?: string; //Attached by the 'scoreMatch' function when filtering the menu.
  duplicate?: boolean; //Attached during processing, I think.
} & Partial<Pick<IScreen, 'id' | 'uuid' | 'concurrencyVersion' | 'folder' | 'sortOrder'>>;

export type ISubMenuSection = {
  [key: string]: Array<IMenuEntry | ISubMenuSection>;
};

//Similar to 'ISubMenuSection' except more specific about the defined submenus.
export type IMenuSection<AdditionalSubMenus = ISubMenuSection> = Array<
  IMenuEntry | { Configuration?: Array<IMenuEntry> } | AdditionalSubMenus
>;

export type IAppMenu = {
  Bank: Array<IMenuEntry | ISubMenuSection>;
  Company: Array<IMenuEntry | ISubMenuSection>;
  Customers: Array<IMenuEntry | ISubMenuSection>;
  Diary: Array<IMenuEntry | ISubMenuSection>;
  Nominal: Array<IMenuEntry | ISubMenuSection>;
  Products: Array<IMenuEntry | ISubMenuSection>;
  Purchasing: Array<IMenuEntry | ISubMenuSection>;
  Reports: Array<IMenuEntry | ISubMenuSection>;
  Sales: Array<IMenuEntry | ISubMenuSection>;
  Suppliers: Array<IMenuEntry | ISubMenuSection>;
  System: Array<IMenuEntry | ISubMenuSection>;
  Vat: Array<IMenuEntry | ISubMenuSection>;
  Web: Array<IMenuEntry | ISubMenuSection>;
};

export const isMenuEntry = (entry: IMenuEntry | ISubMenuSection): entry is IMenuEntry => {
  const menuEntry = entry as IMenuEntry;
  return !!(menuEntry?.title || menuEntry?.url || menuEntry?.screenReference);
};
